import ProductGrid from "@/components/ProductGrid";

export default function Drinkware() {
  return (
    <ProductGrid
      category="drinkware"
      eyebrow="Drinkware Collection"
      title="Every sip, an intention."
      blurb="Ceramic mugs, insulated water bottles, and two-tone tumblers — each piece wears the signature 414 moss + gold palette."
    />
  );
}
